import React from 'react';

import { Typography } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { HeaderLogo } from 'components/BaseComponents/Icons';

import Close from 'assets/images/closeBlack.svg';
import { useAppSelector } from 'antd/redux/store';
import { AccountWrapper, Avatar, CloseIcon, LogoWrapper, useStyles } from '../sidbar.style';

export const Header = ({ onClose, onLogout }) => {
  const classes = useStyles();
  const { users, userType, impersonateOn } = useAppSelector((state) => state.usersSlice);
  const profile = users[userType];

  const matches = useMediaQuery('(max-width:768px)');
  return (
    <LogoWrapper>
      {matches ? (
        <AccountWrapper>
          <div>
            {profile && profile.profilePicture ? (
              <Avatar src={profile.profilePicture} alt='profile pic' />
            ) : (
              <AccountCircle className={classes.headerIcons} />
            )}
            <Typography variant='h4'>{profile.name}</Typography>
          </div>
          <CloseIcon src={Close} alt='Close' onClick={onClose} width={32} height={32} />
        </AccountWrapper>
      ) : (
        <HeaderLogo />
      )}
    </LogoWrapper>
  );
};
